import {
  PhotoGalleryI18n,
  PhotoGalleryProps,
} from '../PhotoGallery/PhotoGallery.types';

export enum AccidentType {
  MECHANICAL_DAMAGE = 'uszkodzenie_mechaniczne',
  BODY_DAMAGE = 'uszkodzenie_nadwozia',
  ENGINE_DAMAGE = 'uszkodzenie_silnika',
  ELECTRICAL_DAMAGE = 'uszkodzenie_elektryczne',
  ACCIDENT = 'wypadek',
  THEFT = 'kradziez',
  FIRE = 'pozar',
  FLOOD = 'powodz',
  HAIL = 'grad',
  VANDALISM = 'wandalizm',
}

export interface AccidentItemHSPI18n {
  /**
   * Main header text
   * @default "Odnotowano szkodę pojazdu"
   */
  damageReportedTitle?: string;
  /**
   * Damage value label
   * @default "Wartość szkody"
   */
  damageValueLabel?: string;
  /**
   * Damage country label
   * @default "Kraj szkody"
   */
  damageCountryLabel?: string;
  /**
   * Event details section title
   * @default "Szczegóły zdarzenia:"
   */
  eventDetailsTitle?: string;
  /**
   * Damaged elements label
   * @default "Elementy które mogły ulec uszkodzeniu:"
   */
  damagedElementsLabel?: string;
  /**
   * Damage location label
   * @default "Miejsce szkody:"
   */
  damageLocationLabel?: string;
  /**
   * Mileage label
   * @default "Przebieg przy wystąpieniu zdarzenia"
   */
  mileageLabel?: string;
  /**
   * Kilometer unit
   * @default "km"
   */
  kmUnit?: string;
  /**
   * Photo gallery title
   * @default "Zdjecia szkód pojazdu"
   */
  photoGalleryTitle?: string;
  /**
   * Flag alt text template
   * Use {country} placeholder for country name
   * @default "Flaga {country}"
   * @example "Flaga {country}" → "Flaga Polska"
   */
  flagAltTemplate?: string;
}

export interface AccidentItemHSPProps {
  /**
   * Fallback images
   */
  fallbackImages?: {
    mainImage: string;
    pointsImages: string[];
  }[];
  /**
   * Date when the damage occurred
   */
  date: string;
  /**
   * Damage value minimum
   */
  damageValueMin?: number;
  /**
   * Damage value maximum
   */
  damageValueMax?: number;
  /**
   * Country where the damage occurred
   */
  damageCountry?: string;
  /**
   * Type of damage from predefined list
   */
  damageType?: AccidentType;
  /**
   * Location of damage on the vehicle
   */
  damageLocation?: string[];
  damageGroups?: string[];
  /**
   * Vehicle mileage when damage occurred (e.g. "85 200 km")
   */
  currency?: string;
  mileage?: string;
  /**
   * Detailed description of the damage
   */
  description?: string;
  /**
   * Additional CSS classes
   */
  positionsIds?: string[];
  className?: string;
  flagUrl?: string;
  photoGallery?: PhotoGalleryProps;
  /**
   * Internationalization texts
   */
  i18n?: AccidentItemHSPI18n & PhotoGalleryI18n;
}

export const ACCIDENT_TYPE_LABELS: Record<AccidentType, string> = {
  [AccidentType.MECHANICAL_DAMAGE]: 'Uszkodzenie mechaniczne',
  [AccidentType.BODY_DAMAGE]: 'Uszkodzenie nadwozia',
  [AccidentType.ENGINE_DAMAGE]: 'Uszkodzenie silnika',
  [AccidentType.ELECTRICAL_DAMAGE]: 'Uszkodzenie elektryczne',
  [AccidentType.ACCIDENT]: 'Wypadek',
  [AccidentType.THEFT]: 'Kradzież',
  [AccidentType.FIRE]: 'Pożar',
  [AccidentType.FLOOD]: 'Powódź',
  [AccidentType.HAIL]: 'Grad',
  [AccidentType.VANDALISM]: 'Wandalizm',
};

export interface CountryInfo {
  name: string;
  flag: string; // flaga jako emoji lub kod flagi
}

export const COUNTRY_FLAGS: Record<string, CountryInfo> = {
  'Wielka Brytania': { name: 'Wielka Brytania', flag: '🇬🇧' },
  Polska: { name: 'Polska', flag: '🇵🇱' },
  Niemcy: { name: 'Niemcy', flag: '🇩🇪' },
  Francja: { name: 'Francja', flag: '🇫🇷' },
  Włochy: { name: 'Włochy', flag: '🇮🇹' },
  Hiszpania: { name: 'Hiszpania', flag: '🇪🇸' },
  Czechy: { name: 'Czechy', flag: '🇨🇿' },
  Austria: { name: 'Austria', flag: '🇦🇹' },
  Holandia: { name: 'Holandia', flag: '🇳🇱' },
  Belgia: { name: 'Belgia', flag: '🇧🇪' },
};
